import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { CommonProvider } from '../common/common.provider';
import { AuthDropboxDefaultProvider, AuthDropboxProvider } from './auth-dropbox.provider';

@NgModule({
  providers: angularProvidersBuilder({
    provide: AuthDropboxProvider,
    deps: [CommonProvider],
    useFactory: (common: CommonProvider) => new AuthDropboxDefaultProvider(common, window),
  }).build(),
})
export class AuthDropboxProviderModule {}
